import { CheckCircle, Clock, Truck, Package } from "lucide-react";
import { StatCard } from "../../home/components/stat-card";
import { DAY_MS, HOUR_MS } from "@/lib/utils/date.ts";

interface TimeStatCardProps {
  title: string;
  duration: number;
  subtitle: string;
  color: string;
  icon?: "check" | "clock" | "truck" | "package";
}

export function TimeStatCard({
  title,
  duration,
  subtitle,
  icon = "clock",
  color,
}: TimeStatCardProps) {
  const IconComponent = {
    check: CheckCircle,
    clock: Clock,
    truck: Truck,
    package: Package,
  }[icon];

  const TIME_BUCKETS = [
    { label: "1h", max: 1 * HOUR_MS },
    { label: "2h", max: 2 * HOUR_MS },
    { label: "3h", max: 3 * HOUR_MS },
    { label: "4h", max: 4 * HOUR_MS },
    { label: "5h", max: 5 * HOUR_MS },
    { label: "6h", max: 6 * HOUR_MS },
    { label: "7h", max: 7 * HOUR_MS },
    { label: "8h", max: 8 * HOUR_MS },
    { label: "24h", max: 24 * HOUR_MS },
    { label: "48h", max: 48 * HOUR_MS },
    { label: "3j", max: 3 * DAY_MS },
    { label: "4j", max: 4 * DAY_MS },
    { label: "> 4j", max: Infinity },
  ];

  function getTimeBucket(ms: number) {
    return TIME_BUCKETS.find((b) => ms <= b.max)?.label || ">4j";
  }

  return (
    <StatCard>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 mb-2 ">
          <IconComponent
            className="w-5 h-5 text-muted-foreground"
            style={{ color }}
          />

          <div className="flex items-center gap-2">
            <div
              className="w-2 h-2 rounded-full hidden sm:block"
              // style={{ backgroundColor: color }}
            />
            <span className="font-medium text-xs">{title}</span>
          </div>
        </div>
        <div className="flex sm:flex-row flex-col gap-2 items-baseline">
          <span className="text-lg">
            {duration === 0 ? "0" : getTimeBucket(duration)}
          </span>
        </div>
        <div className="text-xs text-muted-foreground">{subtitle}</div>
      </div>
    </StatCard>
  );
}
